import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSpecialCharacters'
})
export class RemoveSpecialCharactersPipe implements PipeTransform {
  transform(value: string,  ...args: unknown[]): string {
    if (!value) {
      return value;
    }
    // Regular expression to match special characters
    return value.replace(/[^a-zA-Z0-9 ]/g, ' ');
  }
}
